export default __webpack_public_path__ + "static/media/SbSquares.13275b4b.JPG";